import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { CountUp } from "countup.js";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function AnimatedCountingNumber(
  id: string,
  valueNumber: number,
  decimalPlaces: number = 1
) {
  // Função principal para iniciar a animação
  const animateNumber = () => {
    const target = document.getElementById(id);

    // Verifica se o elemento existe
    if (!target) {
      // console.error("Elemento #animated-number não encontrado.");
      return;
    }

    // Configura o CountUp
    const countUp = new CountUp(target, valueNumber, {
      duration: 0.5, // Duração em segundos
      useEasing: true, // Habilita easing
      separator: ".", // Define separador de milhar
      decimal: ",", // Define separador decimal
      decimalPlaces: decimalPlaces, // Número fixo de casas decimais
    });

    // Verifica se houve erro ao inicializar o CountUp
    if (!countUp.error) {
      countUp.start();
    }
  };

  // Configuração do Intersection Observer
  const observeAnimation = () => {
    const target = document.getElementById(id);

    // Verifica se o elemento existe
    if (!target) {
      // console.error("Elemento #animated-number não encontrado.");
      return;
    }

    // Configuração do Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateNumber();
            observer.disconnect(); // Remover o observador após a animação
          }
        });
      },
      { threshold: 0.5 } // Quando 50% do elemento estiver visível
    );

    observer.observe(target);
  };

  observeAnimation();
}
